import type { ObjectType } from '..';
import { ODATA_CONTROLLER_NAME, ODATA_SERVER_NAME } from './constant';

export default function ODataEntity(server: string, controller?: string): ClassDecorator {
  return function (target: ObjectType<any>) {
    Reflect.defineMetadata(ODATA_SERVER_NAME, server, target);
    Reflect.defineMetadata(ODATA_CONTROLLER_NAME, controller || target.name + 's', target);
  };
}
